import { Cartesian2, Cartesian3, Cartesian4, Color, PolylineOutlineMaterialProperty, } from "cesium";
import { AssetType } from "../../types";
import { CesiumUtils } from "../../utilities/cesium-utils";
import { EarthBrainUtils, } from "../../utilities/earthbrainutility";
/**
 * @deprecated Use EarthbrainDXF
 */
export class DXFWGS84 {
    _id;
    _heightMap;
    // private _entity: Entity[];
    _viewer;
    _site;
    _dxfInfo;
    _renderData;
    constructor(id, viewer, site) {
        this._id = id;
        this._viewer = viewer;
        this._site = site;
        this._dxfInfo = [];
        this._renderData = [];
    }
    addDxfData(dxfOBJ) {
        this.dispose();
        this._dxfInfo = dxfOBJ;
        this._renderDXFData();
    }
    zoomTo() {
        this._renderData.length > 0 &&
            this._viewer.flyTo(this._renderData.map((d) => d.entity));
    }
    get id() {
        return this._id;
    }
    get heightMap() {
        return this._heightMap;
    }
    get assetType() {
        return AssetType.DXF_Data;
    }
    setVisibility(visible) {
        this._renderData.forEach((e) => (e.entity.show = visible));
        this._viewer.scene.requestRender();
    }
    updateColor(color) {
        const material = new PolylineOutlineMaterialProperty({
            color,
            outlineColor: color,
            outlineWidth: 2,
        });
        this._renderData.forEach(({ entity }) => (entity.polyline.material = material));
        this._viewer.scene.requestRender();
    }
    dispose() {
        this._renderData.forEach((e) => this._viewer.entities.remove(e.entity));
        this._dxfInfo.length = 0;
        this._renderData.length = 0;
    }
    async adjustHeight(asset) {
        console.log(asset);
        // try {
        //     for(const info of this._dxfInfo){
        //         info.points3d = info.points.map(p=>{
        //             const ray = new Ray(
        //                 new Cartesian3(p.x, p.y, 0),
        //                 new Cartesian3(0, 0, 1),
        //             );
        //             const pointOnTileset = asset.heightMap.rayCast(ray);
        //             return pointOnTileset ? pointOnTileset : new Cartesian3(p.x, p.y, 0);
        //         })
        //     }
        //     this.renderDXFData();
        // } catch (error) {
        //     console.warn(error);
        // }
    }
    /**
     * Renders polyline entity data & text entity data of DXF
     */
    _renderDXFData() {
        this._dxfInfo.forEach((d) => {
            if (d.polylineData) {
                const material = new PolylineOutlineMaterialProperty({
                    color: d.color,
                    outlineColor: d.color,
                    outlineWidth: 2,
                });
                const entity = CesiumUtils.createPolyLine(d.polylineData, d.id.toString(), 2, material, false, true);
                this._viewer.entities.add(entity);
                this._renderData.push({ entity });
            }
            if (d.textEntityData) {
                const sphere = EarthBrainUtils.addSphere(this._viewer, d.textEntityData.position, d.color);
                const labelSettings = {
                    showBackground: true,
                    fontSize: 15,
                    fillColor: d.color,
                    backgroundColor: new Color(1, 1, 1, 1),
                    backgroundPadding: new Cartesian2(7, 5),
                    disableDepthDistance: Number.POSITIVE_INFINITY,
                };
                const label = EarthBrainUtils.addLabel(this._viewer, d.textEntityData.position, d.textEntityData.textStr, labelSettings);
                this._renderData.push({ entity: sphere });
                this._renderData.push({ entity: label });
            }
        });
        this._viewer.scene.requestRender();
    }
    /**
     * resets the z position of the dxf coordinates to zero
     */
    async resetHeight() {
        // try {
        //     for(const info of this._dxfInfo){
        //         info.points3d = info.points.map(p=>new Cartesian3(p.x, p.y, 0));
        //     }
        //     await this.prepareWGS84Data();
        //     this.renderDXFData();
        // } catch (error) {
        //     console.warn(error);
        // }
    }
    static async fromJSON(id, json, viewer, site, version = 1) {
        switch (version) {
            case 1: {
                let dxfData;
                if (typeof json === "string") {
                    dxfData = JSON.parse(json);
                }
                else if (typeof json === "object") {
                    dxfData = json;
                }
                const dxfObj = [];
                for (let i = 0; i < dxfData.polylines.length; i++) {
                    const polylineData = dxfData.polylines[i].vertices.map((vertex) => new Cartesian3(vertex[0], vertex[1], vertex[2]));
                    dxfObj.push({
                        id: i,
                        color: Color.fromCssColorString(`rgb(${dxfData.polylines[i].rgb})`),
                        polylineData,
                    });
                }
                const dxf = new DXFWGS84(id, viewer, site);
                dxf.addDxfData(dxfObj);
                return dxf;
            }
            case 1.1: {
                let dxfData;
                if (typeof json === "string") {
                    dxfData = JSON.parse(json);
                }
                else if (typeof json === "object") {
                    dxfData = json;
                }
                const dxfObjArr = [];
                for (let i = 0; i < dxfData.polylines.length; i++) {
                    const polylineData = dxfData.polylines[i].vertices.map((vertex) => new Cartesian3(vertex[0], vertex[1], vertex[2]));
                    dxfObjArr.push({
                        id: i,
                        color: Color.fromCssColorString(`rgb(${dxfData.polylines[i].rgb})`),
                        polylineData,
                    });
                }
                for (let i = 0; i < dxfData.entities.length; i++) {
                    const dxfTextEntityData = dxfData.entities[i];
                    const localPosition = new Cartesian3(dxfTextEntityData.x, dxfTextEntityData.y, dxfTextEntityData.z);
                    dxfObjArr.push({
                        id: i,
                        color: Color.fromCartesian4(Cartesian4.fromArray([...dxfTextEntityData.colorNumber, 1])),
                        textEntityData: {
                            localPosition,
                            textStr: dxfTextEntityData.string,
                            position: null,
                        },
                    });
                }
                // As polylines are inserted before geo-located text
                const startIndex = dxfData.polylines.length - 1;
                const wgs84Points = await site.convertPointsToWGS84(dxfObjArr
                    .slice(startIndex)
                    .map((pol) => pol.textEntityData.localPosition));
                for (let i = startIndex; i < dxfObjArr.length; i++) {
                    dxfObjArr[i].textEntityData.position = wgs84Points[i];
                }
                const dxf = new DXFWGS84(id, viewer, site);
                dxf.addDxfData(dxfObjArr);
                return dxf;
            }
            default:
                break;
        }
    }
}
//# sourceMappingURL=dxf-wgs84.js.map